import { render } from "./operator_talk.vue?vue&type=template&id=173d2eb4&scoped=true"
import script from "./operator_talk.vue?vue&type=script&lang=js"
export * from "./operator_talk.vue?vue&type=script&lang=js"

import "./operator_talk.vue?vue&type=style&index=0&id=173d2eb4&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173d2eb4"]])

export default __exports__